import { Switch } from '@headlessui/react'
import clsx from 'clsx'

export interface StockToggleProps {
  enabled: boolean
  onChange: (checked: boolean) => void
}

export function StockToggle({ enabled, onChange }: StockToggleProps) {
  return (
    <div className="mr-8 items-center" style={{ display: 'inherit' }}>
      <Switch.Group>
        <Switch.Label className="mr-2 select-none paragraphOne cursor-pointer">
          BUY ONLINE
        </Switch.Label>
        <Switch
          checked={enabled}
          onChange={onChange}
          className="bg-transparent relative inline-flex items-center h-4 rounded-3xl w-[1.6rem] transition-colors border-[1px] border-solid border-black bg-white"
          data-testid="stockToggle"
        >
          <span
            className={clsx(
              enabled
                ? 'translate-x-3 bg-gray-700'
                : 'translate-x-1 bg-gray-400',
              'inline-block w-2 h-2 transform rounded-full transition-transform',
            )}
          />
        </Switch>
      </Switch.Group>
    </div>
  )
}

export default StockToggle
